import { processingSessionItemIdFormat } from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getProcessingSessionSortDestinations = {
  name: "getProcessingSessionSortDestinations" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    sessionDestination: z.string().nullable(),
    itemDestinations: z.record(
      processingSessionItemIdFormat.schema,
      z.string().nullable(),
    ),
  }),
};
